export const CONTROL_LIMITS = {
  MAX_UNUSED_CONTROLS: 3,
  MAX_HISTORY_STATES: 50,
} as const;

export const CONTROL_MESSAGES = {
  LIMIT_REACHED: 'Control limit reached',
  LIMIT_REACHED_DESC: (max: number) =>
    `You have ${max} unused controls. Please use an existing control in a render or edit an existing one instead.`,
  DELETE_CONFIRMATION: 'Are you sure you want to delete this control?',
  DELETE_USED_WARNING:
    'This control is being used in render history and cannot be deleted.',
  GENERATION_FAILED: 'Control generation failed',
  SAVE_FAILED: 'Failed to save control',
  DELETE_FAILED: 'Failed to delete control',
  VERSION_CREATED: 'New control version created',
  VERSION_CREATED_DESC:
    "The previous version is preserved as it's used in render history. Your new changes are saved in a new version.",
} as const;
